import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../common/shared/services/auth.service';
import { UtilitiesService } from '../../../common/shared/services/utilities.service';
import { environment } from '../../../../environments/environment';
import { NavigationService } from '../../../common/shared/services/navigation.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  email: string;
  password: string;
  hidePW = true;

  constructor(
    private _authService: AuthService,
    private _utilitiesService: UtilitiesService) {
  }

  ngOnInit() {
    this._authService.checkUserLoggedIn();

    this._utilitiesService.removeInitAction(0);
  }

  login() {
    this._utilitiesService.addMinorAction('Login');
    this.hidePW = true;
    this._authService.login(this.email, this.password);
  }

  loginActive() {
    return this._utilitiesService.isActionActive('Login') || this._utilitiesService.isActionActive('CheckConsent');
  }

  toggleHidePW() {
    if (!this.loginActive()) {
      this.hidePW = !this.hidePW;
    }
  }
}
